export const TRACK_EVENT_DIALOG_DEFAULT_TEMPLATE = {
  op: 'ui',
  name: 'Box',
  'data-testid': 'trip-event-detail-drawer',
  style: {
    op: 'context',
    path: 'ui.styles.drawer',
  },
  children: {
    op: 'ui',
    name: 'Stack',
    spacing: {
      op: 'context',
      path: 'ui.layout.drawerSpacing',
    },
    style: {
      op: 'context',
      path: 'ui.styles.drawerStack',
    },
    children: [
      {
        op: 'ui',
        name: 'Box',
        style: {
          op: 'context',
          path: 'ui.styles.header',
        },
        children: {
          op: 'ui',
          name: 'Stack',
          alignItems: 'center',
          direction: 'row',
          justifyContent: 'space-between',
          spacing: {
            op: 'context',
            path: 'ui.layout.headerSpacing',
          },
          children: [
            {
              op: 'ui',
              name: 'Stack',
              alignItems: 'center',
              direction: 'row',
              spacing: 1,
              style: { minWidth: 0 },
              children: [
                {
                  op: 'ui',
                  name: 'Box',
                  style: {
                    op: 'context',
                    path: 'ui.styles.marker',
                  },
                },
                {
                  op: 'ui',
                  name: 'Stack',
                  spacing: 0.25,
                  style: { minWidth: 0 },
                  children: [
                    {
                      op: 'ui',
                      name: 'Typography',
                      style: { fontWeight: 600 },
                      variant: {
                        op: 'context',
                        path: 'ui.layout.eventTitleVariant',
                      },
                      children: {
                        op: 'context',
                        path: 'ui.labels.title',
                      },
                    },
                    {
                      op: 'if',
                      condition: {
                        op: 'context',
                        path: 'ui.labels.summaryText',
                      },
                      then: {
                        op: 'ui',
                        name: 'Typography',
                        color: 'text.secondary',
                        variant: 'body2',
                        children: {
                          op: 'context',
                          path: 'ui.labels.summaryText',
                        },
                      },
                      else: null,
                    },
                  ],
                },
              ],
            },
            {
              op: 'ui',
              name: 'Stack',
              alignItems: 'center',
              direction: 'row',
              spacing: 1,
              children: [
                {
                  op: 'ui',
                  name: 'Tooltip',
                  title: {
                    op: 'context',
                    path: 'ui.labels.previous',
                  },
                  children: {
                    op: 'ui',
                    name: 'IconButton',
                    'data-testid': 'previous-button',
                    disabled: {
                      op: 'context',
                      path: 'ui.actions.previousDisabled',
                    },
                    onClick: {
                      op: 'context',
                      path: 'ui.actions.onPrevious',
                    },
                    size: 'small',
                    children: {
                      op: 'ui',
                      name: 'Icon',
                      icon: 'ChevronLeft',
                    },
                  },
                },
                {
                  op: 'ui',
                  name: 'Tooltip',
                  title: {
                    op: 'context',
                    path: 'ui.labels.next',
                  },
                  children: {
                    op: 'ui',
                    name: 'IconButton',
                    'data-testid': 'next-button',
                    disabled: {
                      op: 'context',
                      path: 'ui.actions.nextDisabled',
                    },
                    onClick: {
                      op: 'context',
                      path: 'ui.actions.onNext',
                    },
                    size: 'small',
                    children: {
                      op: 'ui',
                      name: 'Icon',
                      icon: 'ChevronRight',
                    },
                  },
                },
                {
                  op: 'ui',
                  name: 'IconButton',
                  'aria-label': {
                    op: 'context',
                    path: 'ui.labels.close',
                  },
                  'data-testid': 'event-detail-close-button',
                  onClick: {
                    op: 'context',
                    path: 'ui.actions.onClose',
                  },
                  size: 'small',
                  children: {
                    op: 'ui',
                    name: 'Icon',
                    icon: 'CloseIcon',
                  },
                },
              ],
            },
          ],
        },
      },
      {
        op: 'ui',
        name: 'Box',
        style: {
          op: 'context',
          path: 'ui.styles.content',
        },
        children: {
          op: 'ui',
          name: 'Stack',
          spacing: {
            op: 'context',
            path: 'ui.layout.drawerSpacing',
          },
          children: [
            {
              op: 'ui',
              name: 'Box',
              style: {
                op: 'context',
                path: 'ui.styles.eventDataCard',
              },
              children: {
                op: 'ui',
                name: 'Stack',
                spacing: 1,
                style: {
                  op: 'context',
                  path: 'ui.styles.eventDataSection',
                },
                children: [
                  {
                    op: 'ui',
                    name: 'Typography',
                    color: 'text.secondary',
                    variant: {
                      op: 'context',
                      path: 'ui.layout.sectionTitleVariant',
                    },
                    children: {
                      op: 'context',
                      path: 'ui.labels.eventData',
                    },
                  },
                  {
                    op: 'ui',
                    name: 'Box',
                    children: {
                      op: 'context',
                      path: 'ui.content.eventData',
                    },
                  },
                ],
              },
            },
            {
              op: 'ui',
              name: 'Box',
              style: {
                op: 'context',
                path: 'ui.styles.mediaCard',
              },
              children: {
                op: 'ui',
                name: 'Stack',
                spacing: 1,
                children: [
                  {
                    op: 'ui',
                    name: 'Typography',
                    color: 'text.secondary',
                    variant: {
                      op: 'context',
                      path: 'ui.layout.sectionTitleVariant',
                    },
                    children: {
                      op: 'context',
                      path: 'ui.labels.media',
                    },
                  },
                  {
                    op: 'ui',
                    name: 'Box',
                    children: {
                      op: 'context',
                      path: 'ui.content.media',
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  },
};
